export default "__VITE_ASSET__28beabdc__"